import type { SectionOut } from "@/pages/human-resources/time-management/endpoints/reference/domain/inout/SectionOut.ts";
import axios from "axios";

export async function getSections(domainId: string): Promise<SectionOut[]> {
  const { data } = await axios.get<SectionOut[]>(
    `/api/hr/sections/domain/${domainId}`,
  );
  return data;
}
